export default "__VITE_ASSET__B3v$reLx__"